export default (presetFlightSearchString = '') => {
  const [, fromAirport, departureDate, returnDate] = presetFlightSearchString.match(/([A-Z]{3})_(\d{4}-\d{2}-\d{2})_(\d{4}-\d{2}-\d{2})/) || []

  return {
    fromAirport,
    departureDate,
    returnDate,
  }
}